import axios from 'axios';
import { API_PATH } from 'config';
import { getAccessTokenApi } from './auth';

const auth = () => ({ headers: { Authorization: getAccessTokenApi() } });
const base = (idHallazgo) => `${API_PATH}/actividades-hallazgo/${idHallazgo}/imagenes`;

export async function presignHallazgoImagenUpload(idHallazgo, contentType) {
  const { data } = await axios.post(`${base(idHallazgo)}/presign-upload`, { contentType }, auth());
  return { uploadUrl: data.uploadUrl, key: data.key };
}

export async function confirmHallazgoImagen(idHallazgo, key) {
  const { data } = await axios.post(`${base(idHallazgo)}/confirm`, { key }, auth());
  return data.imagen;
}

export async function listHallazgoImagenes(idHallazgo) {
  const { data } = await axios.get(base(idHallazgo), auth());
  return data; // [{ id, orden, url }]
}

export async function deleteHallazgoImagen(idHallazgo, imagenId) {
  await axios.delete(`${base(idHallazgo)}/${imagenId}`, auth());
}
